export default __webpack_public_path__ + "static/media/filters.0d790e13.png";